import React, { useRef } from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import './mobile.css'

const services = [
  { title: 'Chat with Astrologer', link: '/astrologer', desc: 'Instant chat with experts', icon: '/assets/images/chat-with-astrologer.jpg' },
  { title: 'Astroscope Store', link: '/categories', desc: 'Spiritual products', icon: '/assets/images/astro-store.jpg' },
  { title: "Today's Horoscope", link: '/horoscope/aries', desc: 'Daily predictions', icon: '/assets/images/horoscope.jpg' },
  { title: 'Free Kundli', link: '/free-kundli', desc: 'Generate birth chart', icon: '/assets/images/kundli.webp' },
  { title: 'Kundli Matching', link: '/free-kundli', desc: 'Check compatibility', icon: '/assets/images/match.jpg' },
  { title: 'Book a Pooja', link: '#', desc: 'Book ritual', icon: '/assets/images/book-a-pooja.jpeg' },
  { title: 'Talk to Astrologer', link: '/astrologer', desc: 'Voice call with experts', icon: '/assets/images/talk with astrologer.jpg' },
  { title: 'Numerology', link: '/free-kundli', desc: 'Zodiac Sign', icon: '/assets/images/numerology.webp' }
]

const ServicesCarousel = () => {
  const sliderRef = useRef(null)

  const CustomPrevArrow = ({ onClick }) => (
    <button className="custom-carousel-btn custom-carousel-prev" onClick={onClick} type="button">
      <i className="fas fa-chevron-left"></i>
    </button>
  )
  const CustomNextArrow = ({ onClick }) => (
    <button className="custom-carousel-btn custom-carousel-next" onClick={onClick} type="button">
      <i className="fas fa-chevron-right"></i>
    </button>
  )

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      {
        breakpoint: 768,
        settings: "unslick" // Disable slick on mobile
      }
    ]
  }

  return (
    <section className="as_popular_products_wrapper  as_padderBottom80">
      <div className="container">
        <div className="row">
          {/* <div className="row mb-4"> */}
            <div className="col-12 text-center">
              <h1 className="as_heading as_heading_center">Our Services</h1>
            </div>
          {/* </div> */}
          <div className="col-12">
            {/* Desktop View */}
            <div className="v3_blog_wrapper position-relative">
              <div className="row text-left d-none d-md-block">
                <Slider {...settings} ref={sliderRef}>
                  {services.map((srv, idx) => (
                    <div key={idx} className="p-3">
                      <Link to={srv.link} className="text-decoration-none">
                        <div className="product-card h-100 text-center">
                          <img src={srv.icon} alt={srv.title} className="card-img" />
                          <h4 className="card-name mt-3">{srv.title}</h4>
                        </div>
                      </Link>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
            {/* Mobile View */}
            <div className="d-md-none">
              <div className="services-carousel-mobile">
                {services.map((srv, idx) => (
                  <div key={idx} className="service-item">
                    <Link to={srv.link} className="text-decoration-none">
                      <div className="product-card h-100 text-center p-3">
                        <img src={srv.icon} alt={srv.title} className="card-img" />
                        <h4 className="card-name mt-2">{srv.title}</h4>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServicesCarousel 